import { render } from "./KeyHelpModal.vue?vue&type=template&id=26ae1d68"
import script from "./KeyHelpModal.vue?vue&type=script&lang=js"
export * from "./KeyHelpModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__